// all performance traces start with "!" to make them easy to find in firebase (as other GQL traces live in there too)
export enum TraceName {
  // APP START
  APP_START_INIT_LAUNCHDARKLY = '!app_start_init_launchdarkly',
  APP_START_INIT_AMPLITUDE = '!app_start_init_amplitude',
  APP_START_INIT_EXPERIMENTS = '!app_start_init_experiments',
  // starts in first lines of JS app, ends when SHP is visible
  JAVASCRIPT_START_TO_SIMPLE_HOME_PAGE_LOADED = '!javascript_start_to_simple_home_page_loaded',

  // how long it takes to get the user's location from the device
  GET_USER_LOCATION = '!get_user_location',

  // TAB NAV
  HOME_LOAD = '!home_load', // this probably doesn't fire unless home happens to reload somehow
  MENU_LOAD = '!menu_load', // includes "order pickup" press too, first menu item visible
  MY_CODE_LOAD = '!my_code_load',
  OFFERS_LOAD = '!offers_load',
  REWARDS_LOAD = '!rewards_load',

  // MENU
  MENU_SECTION_LOAD = '!menu_section_load', // image is visible for section tile
  MENU_PDP_LOAD = '!menu_pdp_load', // image is visible on PDP`

  // STORE LOCATOR
  // if location is allowed - first mount of store locator page to when the first restaurant appears in the list
  STORE_LOCATOR_AUTO_NEARBY_LOCATION_SEARCH_TO_LIST_ITEM_DISPLAYED = '!store_locator_auto_nearby_location_search_to_list_item_displayed',
  // time it takes for already selected restaurant to appear in the list
  STORE_LOCATOR_RESTAURANT_ALREADY_SELECTED_TO_LIST_ITEM_DISPLAYED = '!store_locator_restaurant_already_selected_to_list_item_displayed',
  // manual search
  STORE_LOCATOR_MANUAL_SEARCH_LOCATION_PRESSED_TO_LIST_ITEM_DISPLAYED = '!store_locator_manual_search_pressed_to_list_item_displayed',
  // locator order here -> first menu item rendered
  STORE_LOCATOR_ORDER_HERE_TO_MENU_ITEMS_DISPLAYED_STORE_ALREADY_SELECTED = '!store_locator_order_here_to_menu_items_displayed_store_already_selected',
  STORE_LOCATOR_ORDER_HERE_TO_MENU_ITEMS_DISPLAYED_STORE_NOT_ALREADY_SELECTED = '!store_locator_order_here_to_menu_items_displayed_store_not_already_selected',

  // AUTH
  AUTH_MODAL_LOAD = '!auth_modal_load',
  OTP_FLOW = '!otp_flow', // email shown -> auth successful

  // OFFERS / REWARDS
  OFFER_DETAIL_LOAD = '!offer_detail_load',
  REWARD_DETAIL_LOAD = '!reward_detail_load',

  // CART
  PRICE_ORDER = '!price_order',
  CART_LOAD_TO_CONTINUE_LOADED = '!cart_load_to_continue_loaded',
  PLACE_ORDER_TO_RECEIPT = '!place_order_to_receipt',
}
